<template>
    <div class="popper" :id="'v-step-' + hash" :ref="'v-step-' + hash">
        <slot name="header">
            <div class="row q-mb-sm">
                <div class="col">
                    <h6 class="q-mt-xs q-mb-none q-pa-none">{{ step.title }}</h6>
                </div>
                <div class="col-auto">
                    <v-button round size="sm" flat color="light"
                              icon="close"
                              class="no-shadow"
                              @click="stop"></v-button>
                </div>
            </div>
        </slot>

        <slot name="content">
            <div class="popper__content">
                <div v-if="step.content" v-html="step.content"></div>
                <div v-else>This is a demo step! The id of this step is {{ hash }} and it targets {{ step.target }}.
                </div>
            </div>
        </slot>

        <slot name="actions">
            <div class="row items-center q-mt-sm">
                <div class="col-auto">
                    <v-button rounded outline no-caps dense color="light"
                              icon="arrow back"
                              class="no-shadow"
                              @click="previousStep"
                              :disable="isFirst"
                              :label="$T('previous')"></v-button>
                </div>
                <div class="col text-center">
                    {{ index+1 }} / {{ total }}
                </div>
                <div class="col-auto">
                    <v-button rounded outline no-caps dense color="light"
                              icon-right="arrow forward"
                              class="no-shadow"
                              @click="nextStep"
                              :disable="isLast"
                              :label="$T('next')"></v-button>
                </div>
            </div>
        </slot>

        <div class="popper__arrow" x-arrow></div>
    </div>
</template>

<script>
    import Popper from 'popper.js'
    import sum from 'hash-sum'

    const DEFAULT_STEP_OPTIONS = {
        placement: 'bottom'
    }

    export default {
        name: 'v-step',
        props: {
            step: Object,
            previousStep: Function,
            nextStep: Function,
            stop: Function,
            isFirst: Boolean,
            isLast: Boolean,
            index: Number,
            total: Number,
        },
        data() {
            return {
                hash: sum(this.step.target)
            }
        },
        computed: {
            params() {
                return {
                    ...DEFAULT_STEP_OPTIONS,
                    ...this.step.params
                }
            }
        },
        mounted() {
            let targetElement = document.querySelector(this.step.target)

            if (targetElement) {
                targetElement.scrollIntoView({behavior: 'smooth'})

                /* eslint-disable no-new */
                new Popper(
                    targetElement,
                    this.$refs['v-step-' + this.hash],
                    this.params
                )
            } else {
                console.error('[Vue Tour] The target element ' + this.step.target + ' of .v-step[id="' + this.hash + '"] does not exist!')
                this.stop()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/VStep.vue